import { useEffect, useState } from "react";

const navLinks = [
  { label: "本周瓜", href: "#weekly" },
  { label: "本月盘点", href: "#monthly" },
  { label: "事件合集", href: "#collection" },
  { label: "热门人物", href: "#people" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const topStyle = !scrolled;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        topStyle ? "bg-transparent" : "border-b border-background-200 bg-background-50/90 backdrop-blur-md"
      }`}
    >
      <nav
        className={`mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 transition-colors md:h-18 md:px-6 ${
          topStyle ? "text-white" : "text-foreground-800"
        }`}
        aria-label="主导航"
      >
        <a href="#top" className="flex items-center gap-2" aria-label="最新吃瓜 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-white">
            <i className="ri-fire-fill text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-tight">最新吃瓜</span>
            <span className="mt-0.5 text-[10px] font-medium opacity-70">近期热门事件一网打尽</span>
          </span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-semibold text-foreground-800/80 transition-colors hover:text-primary-500"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-accent-600 md:inline-flex"
          >
            订阅瓜报
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${topStyle ? "text-white" : "text-foreground-800"}`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-fill text-xl"} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-semibold text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-accent-500 px-4 py-2.5 text-sm font-bold text-white"
            >
              订阅瓜报
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}